/*import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../storage-service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  private apiUrl = ''; // será carregada do IndexedDB

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  // Carrega a URL do servidor
  private async initApiUrl(): Promise<void> {
    const servidor = await this.storageService.getServidor();
    if (servidor?.url_servidor) {
      this.apiUrl = `${servidor.url_servidor}/auth`;
    } else {
      this.apiUrl = 'https://i9fluir.com.br:8082/api/auth';
    }
  }

  // Enviar email de recuperação
  enviarEmailRecuperacao(usuarioId: number, emailDestino: string): Observable<string> {
    return new Observable<string>((observer) => {
      this.initApiUrl().then(() => {

        const params = new HttpParams().set('emailDestino', emailDestino);

        this.http.post(
          `${this.apiUrl}/forgot-password/${usuarioId}`,
          {},
          { params, responseType: 'text' }
        ).subscribe({
          next: (response) => observer.next(response),
          error: (error) => observer.error(error)
        });

      });
    });
  }

  // Redefinir senha usando o token enviado no e-mail
  resetarSenha(token: string, novaSenha: string): Observable<string> {
    return new Observable<string>((observer) => {
      this.initApiUrl().then(() => {

        const params = new HttpParams()
          .set('token', token)
          .set('novaSenha', novaSenha);

        this.http.post(
          `${this.apiUrl}/reset-password`,
          {},
          { params, responseType: 'text' }
        ).subscribe({
          next: (response) => observer.next(response),
          error: (error) => observer.error(error)
        });

      });
    });
  }

}*/

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) {}

  enviarEmailRecuperacao(
    usuarioId: number,
    emailDestino: string
  ): Observable<string> {

    const params = new HttpParams()
      .set('emailDestino', emailDestino);

    return this.http.post(
      `/auth/forgot-password/${usuarioId}`,
      {},
      { params, responseType: 'text' }
    );
  }

  resetarSenha(
    token: string,
    novaSenha: string
  ): Observable<string> {

    const params = new HttpParams()
      .set('token', token)
      .set('novaSenha', novaSenha);

    return this.http.post(
      `/auth/reset-password`,
      {},
      { params, responseType: 'text' }
    );
  }
}